import { createContext, type ReactNode, use } from "react";

/**
 * DocsPathnameContext carries the active page pathname through the shell so the
 * sidebar can mark the current link active. The pathname is resolved once at the
 * top (from the prop the prerender passes, or `window.location` on the client)
 * and read wherever active state is needed, rather than threaded as a repeated
 * prop — the provider is the single source of the current location for the
 * chrome, working identically during prerender and after hydration.
 */
const DocsPathnameContext = createContext<string>("/");

/**
 * DocsPathnameProviderProps carry the active pathname and the subtree that reads
 * it.
 */
interface DocsPathnameProviderProps {
  children: ReactNode;
  pathname: string;
}

/**
 * DocsPathnameProvider publishes the active pathname to the shell subtree.
 */
export const DocsPathnameProvider = ({ children, pathname }: DocsPathnameProviderProps) => (
  <DocsPathnameContext value={pathname}>{children}</DocsPathnameContext>
);

/**
 * useDocsPathname reads the active page pathname published by the shell.
 */
export const useDocsPathname = (): string => use(DocsPathnameContext);
